// Import from @phosphor-icons/react/dist/csr/<icon-name> to optimize performance:
// https://github.com/phosphor-icons/react?tab=readme-ov-file#import-performance-optimization

import { ArrowLeftIcon } from "@phosphor-icons/react/dist/csr/ArrowLeft";
import { ArrowSquareOutIcon } from "@phosphor-icons/react/dist/csr/ArrowSquareOut";
import { CalendarBlankIcon } from "@phosphor-icons/react/dist/csr/CalendarBlank";
import { CalendarCheckIcon } from "@phosphor-icons/react/dist/csr/CalendarCheck";
import { ChatIcon } from "@phosphor-icons/react/dist/csr/Chat";
import { CheckIcon as PhosphorCheckIcon } from "@phosphor-icons/react/dist/csr/Check";
import { CloudArrowDownIcon } from "@phosphor-icons/react/dist/csr/CloudArrowDown";
import { CompassIcon } from "@phosphor-icons/react/dist/csr/Compass";
import { CopyIcon as PhosphorCopyIcon } from "@phosphor-icons/react/dist/csr/Copy";
import { FileArrowDownIcon } from "@phosphor-icons/react/dist/csr/FileArrowDown";
import { HeadCircuitIcon } from "@phosphor-icons/react/dist/csr/HeadCircuit";
import { HouseIcon } from "@phosphor-icons/react/dist/csr/House";
import { InfoIcon } from "@phosphor-icons/react/dist/csr/Info";
import { MicroscopeIcon } from "@phosphor-icons/react/dist/csr/Microscope";
import { NoteIcon } from "@phosphor-icons/react/dist/csr/Note";
import { NotePencilIcon } from "@phosphor-icons/react/dist/csr/NotePencil";
import { PaperPlaneRightIcon } from "@phosphor-icons/react/dist/csr/PaperPlaneRight";
import { PencilIcon } from "@phosphor-icons/react/dist/csr/Pencil";
import { PlusCircleIcon } from "@phosphor-icons/react/dist/csr/PlusCircle";
import { PrinterIcon } from "@phosphor-icons/react/dist/csr/Printer";
import { PushPinIcon } from "@phosphor-icons/react/dist/csr/PushPin";
import { SignOutIcon } from "@phosphor-icons/react/dist/csr/SignOut";
import { ThumbsDownIcon } from "@phosphor-icons/react/dist/csr/ThumbsDown";
import { ThumbsUpIcon } from "@phosphor-icons/react/dist/csr/ThumbsUp";
import { TrashIcon } from "@phosphor-icons/react/dist/csr/Trash";
import { UserCircleIcon } from "@phosphor-icons/react/dist/csr/UserCircle";
import { XIcon } from "@phosphor-icons/react/dist/csr/X";
import { MouseEventHandler } from "react";

import { chatGreen, chatProfile, menu, menuClose } from "@/components/ui/icon/svg-icons";

interface Props {
    alt?: string;
    className?: string;
    onClick?: MouseEventHandler<SVGElement | HTMLImageElement>;
}

const createProps = (props: Props) => ({
    "aria-label": props.alt,
    ...props,
});

export const AddIcon = (props: Props) => <PlusCircleIcon {...createProps(props)} weight="fill" />;
export const AgentIcon = (props: Props) => <HeadCircuitIcon {...createProps(props)} weight="fill" />;
export const AssistantMessageIcon = (props: Props) => <img src={chatProfile} {...createProps(props)} alt="" />;
export const CancelIcon = (props: Props) => <XIcon {...createProps(props)} weight="bold" />;
export const CloseIcon = (props: Props) => <XIcon {...createProps(props)} weight="bold" />;
export const ConfirmIcon = (props: Props) => <PhosphorCheckIcon {...createProps(props)} weight="bold" />;
export const CopyIcon = (props: Props) => <PhosphorCopyIcon {...createProps(props)} weight="bold" />;
export const DeleteIcon = (props: Props) => <TrashIcon {...createProps(props)} weight="fill" />;
export const DisclaimerInfoIcon = (props: Props) => <InfoIcon {...createProps(props)} weight="fill" />;
export const DownloadAllIcon = (props: Props) => <FileArrowDownIcon {...createProps(props)} weight="fill" />;
export const DownloadIcon = (props: Props) => <CloudArrowDownIcon {...createProps(props)} weight="bold" />;
export const EditTitleIcon = (props: Props) => <PencilIcon {...createProps(props)} weight="fill" />;
export const HintInfoIcon = (props: Props) => <InfoIcon {...createProps(props)} weight="fill" />;
export const HomeIcon = (props: Props) => <HouseIcon {...createProps(props)} weight="fill" />;
export const ChatCardIcon = (props: Props) => <img src={chatGreen} {...createProps(props)} alt="" />;
export const ChatContextIcon = (props: Props) => <NoteIcon {...createProps(props)} weight="bold" />;
export const CheckIcon = (props: Props) => <PhosphorCheckIcon {...createProps(props)} weight="bold" />;
export const LinkOutIcon = (props: Props) => <ArrowSquareOutIcon {...createProps(props)} weight="bold" />;
export const LogoutIcon = (props: Props) => <SignOutIcon {...createProps(props)} weight="bold" />;
export const MenuCloseIcon = (props: Props) => <img src={menuClose} {...createProps(props)} alt="" />;
export const MenuIcon = (props: Props) => <img src={menu} {...createProps(props)} alt="" />;
export const MessageIcon = (props: Props) => <ChatIcon {...createProps(props)} weight="fill" />;
export const NavigateBackIcon = (props: Props) => <ArrowLeftIcon {...createProps(props)} weight="bold" />;
export const NegativeFeedbackActiveIcon = (props: Props) => <ThumbsDownIcon {...createProps(props)} weight="fill" />;
export const NegativeFeedbackIcon = (props: Props) => <ThumbsDownIcon {...createProps(props)} weight="bold" />;
export const PinActiveIcon = (props: Props) => <PushPinIcon {...createProps(props)} weight="fill" />;
export const PinIcon = (props: Props) => <PushPinIcon {...createProps(props)} weight="bold" />;
export const PositiveFeedbackActiveIcon = (props: Props) => <ThumbsUpIcon {...createProps(props)} weight="fill" />;
export const PositiveFeedbackIcon = (props: Props) => <ThumbsUpIcon {...createProps(props)} weight="bold" />;
export const PrintIcon = (props: Props) => <PrinterIcon {...createProps(props)} weight="bold" />;
export const QuickLinkIcon = (props: Props) => <CompassIcon {...createProps(props)} weight="bold" />;
export const ReleaseNotesIcon = (props: Props) => <NotePencilIcon {...createProps(props)} weight="bold" />;
export const ReusePromptIcon = (props: Props) => <PencilIcon {...createProps(props)} weight="bold" />;
export const ScientificTestingIcon = (props: Props) => <MicroscopeIcon {...createProps(props)} weight="fill" />;
export const SubmitIcon = (props: Props) => <PaperPlaneRightIcon {...createProps(props)} weight="fill" />;
export const TrialEventsIcon = (props: Props) => <CalendarCheckIcon {...createProps(props)} weight="fill" />;
export const TrialStartDateIcon = (props: Props) => <CalendarBlankIcon {...createProps(props)} weight="bold" />;
export const UserMenuIcon = (props: Props) => <UserCircleIcon {...createProps(props)} weight="bold" />;
export const UserMessageIcon = (props: Props) => <UserCircleIcon {...createProps(props)} weight="fill" />;
